import { Stack, styled } from '@mui/material';

export const UpdatePersonalInfoDetailCard = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[4],
  width: '100%',
  padding: theme.spacing(2),
  alignItems: 'unset',
  WebkitAlignItems: 'unset',
  '.MuiButton-root': {
    display: 'block',
    margin: `0 auto`,
    padding: 0,
  },
}));
